import React from 'react'
import styled from 'react-emotion'

import cloudbedsBtn from '../../assets/cloudbeds-app-button-bg.png'

const CloudButton = styled.a`
  cursor: pointer;
  color: white;
  text-decoration: none;
  display: inline-block;
  margin: 0;
  padding: 0;
  width: 185px;
  height: 37px;

  &:hover {
    background-position-y: 37px;
  }
`

const CloudbedsButton = (props) => {
  const redirectURI = encodeURIComponent('https://gze6w2ai62.execute-api.us-west-2.amazonaws.com/prod/cloudbeds/oauth_code')
  const clientId = encodeURIComponent('whistle_C8Wua1y63JAXMwqmUr0cieh2')
  const scope = 'read%3Aguest+read%3Ahotel+read%3Areservation+read%3Aroom'
  const url = `https://hotels.cloudbeds.com/api/v1.1/oauth?client_id=${clientId}&redirect_uri=${redirectURI}&response_type=code&scope=${scope}`
  
  return (
    <CloudButton
      href={url}
      title="Connect with CloudBeds"
      style={{
        backgroundImage: `url(${cloudbedsBtn})`
      }}
    />
  );
}

export default CloudbedsButton



// WEBPACK FOOTER //
// ./src/components/buttons/CloudBedsButton.js